import _Cached from "@mui/icons-material/Cached";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { COLORS } from '@fupa/fupa-uikit';
import { Heading, IconContainer, LinkContainer, LinkText, StyledLink, Subtitle, Title, Wrapper } from 'app/components/styles/districtModules/headerStyles';
import styled from 'styled-components';
const StyledWrapper = styled(Wrapper).withConfig({
  componentId: "sc-ekanye-0"
})(["&&&{border-bottom:1px solid ", ";", "}"], COLORS.lightGrey, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      border-bottom: none;\n    "]))));
export default function TransferModuleHeader(_ref) {
  let {
    districtSlug
  } = _ref;
  // Todo: add link to District-Model as soon as AllTransfersPage is out of beta
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    "data-sentry-element": "StyledWrapper",
    "data-sentry-component": "TransferModuleHeader",
    "data-sentry-source-file": "TransferModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    color: COLORS.orange,
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "TransferModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(_Cached, {
    style: {
      color: COLORS.white,
      fontSize: 'inherit'
    },
    "data-sentry-element": "Cached",
    "data-sentry-source-file": "TransferModuleHeader.tsx"
  })), /*#__PURE__*/React.createElement(Heading, {
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "TransferModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(Title, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "TransferModuleHeader.tsx"
  }, "Transfers"), /*#__PURE__*/React.createElement(Subtitle, {
    variant: "caption3",
    "data-sentry-element": "Subtitle",
    "data-sentry-source-file": "TransferModuleHeader.tsx"
  }, "Die aktuellen Wechsel")), districtSlug ? /*#__PURE__*/React.createElement(LinkContainer, null, /*#__PURE__*/React.createElement(StyledLink, {
    to: "/test_region/".concat(districtSlug, "/transfers"),
    decoration: "underline",
    rel: "nofollow"
  }, /*#__PURE__*/React.createElement(LinkText, {
    variant: "caption3"
  }, 'Alle Transfers >'))) : null);
}